jQuery.noConflict();
jQuery(document).ready(function(){ 
    if( $('.sliderformations').length > 0 ) {

     
        $('.sliderformations_elements').owlCarousel({
            dots: true,
            
            responsive : {
                // breakpoint from 0 up
                0 : {
                    nav: false,
                    items: 1,
                    loop: false,
                    margin: 15,
                    stagePadding: 30 
                },
                // breakpoint from 480 up
                425 : {
                    nav: false,
                    loop: true,
                    items: 2,
                    margin: 30,
                },
                // breakpoint from 425 up
                768 : {
                    nav: true,
                    navText: ["<img src='wp-content/themes/index/assets/images/pictos/element_arrow_left.svg'>","<img src='wp-content/themes/index/assets/images/pictos/element_arrow_right.svg'>"],
                    loop: true,
                    margin: 20,
                    items: 3
                }
            }
        })
    }
});
